import { render, staticRenderFns } from "./_loading.vue?vue&type=template&id=194bb1d4&scoped=true&"
import script from "./_loading.vue?vue&type=script&lang=js&"
export * from "./_loading.vue?vue&type=script&lang=js&"
import style0 from "./_loading.vue?vue&type=style&index=0&id=194bb1d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194bb1d4",
  null
  
)

export default component.exports